var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReason1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "940.048 1651.571 77.34 78.64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Urban_Renewal_Tool_-_Homepage_1366px_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4535
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Urban_Renewal_Tool_-_Homepage_1366px_",
    "data-name": "Urban Renewal Tool - Homepage 1366px ",
    className: "cls-3",
    style: {
      clipPath: "url(#clip-Urban_Renewal_Tool_-_Homepage_1366px_)"
    },
    transform: "matrix(1, 0, 0, 1, 67.621826, -1705.269897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon1",
    "data-name": "hp_impact renewal_icon1",
    transform: "matrix(1, 0, 0, 1, 875.656494, 3358.842529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    className: "cls-1036",
    d: "M6467.854,6780.679h5.978l8.968,4.483v-16.439l-8.968,4.483h-5.978a2.989,2.989,0,0,0-2.99,2.989v1.493A2.99,2.99,0,0,0,6467.854,6780.679Z",
    transform: "translate(-6435.383 -6764.413)",
    style: {
      fill: "rgb(215, 220, 228)",
      stroke: "rgb(215, 220, 228)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    className: "cls-1014",
    d: "M6446.833,6785.567a6.126,6.126,0,0,0,5.978-6.405v-2.135a5.993,5.993,0,1,0-11.957,0v2.135A6.125,6.125,0,0,0,6446.833,6785.567Z",
    transform: "translate(-6433.382 -6764.643)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    className: "cls-1014",
    d: "M6451.78,6834.167v-32.88l4.051,2.026a2.991,2.991,0,0,0,3.451-.56l4.455-4.454c3.3-3.052,3.924-5.979,1.495-8.968-3.052,2.615-5.916,4.919-7.473,5.978-1.993-1.058-4.359-2.864-7.474-2.989h-10.461c-5.356,0-7.473,2.26-7.473,8.968v10.462a6,6,0,0,0,5.978,5.979h0",
    transform: "translate(-6432.351 -6765.348)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    className: "cls-1014",
    y2: 20.924,
    transform: "translate(13.763 47.895)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    className: "cls-1014",
    y2: 32.881,
    transform: "translate(5.978 35.938)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    className: "cls-1014",
    d: "M6464.253,6784.278h5.979l8.966,4.484v-16.44l-8.966,4.483h-5.979a2.989,2.989,0,0,0-2.989,2.99v1.495A2.989,2.989,0,0,0,6464.253,6784.278Z",
    transform: "translate(-6435.048 -6764.849)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    className: "cls-1014",
    y1: 2.989,
    transform: "translate(33.645 19.902)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    className: "cls-1014",
    d: "M6488.477,6775.844a7.474,7.474,0,0,1,0,10.569",
    transform: "translate(-6437.971 -6764.984)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    className: "cls-1014",
    d: "M6494.49,6769.831a14.946,14.946,0,0,1,0,21.137",
    transform: "translate(-6438.34 -6764.547)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    className: "cls-1014",
    d: "M6500.5,6763.818a22.419,22.419,0,0,1,0,31.705",
    transform: "translate(-6439.069 -6763.818)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason1);
export default __webpack_public_path__ + "static/media/reason1.a3d96f2601554729120150f14c67a24a.svg";
export { ForwardRef as ReactComponent };